import { ConfigProvider, Pagination, PaginationProps } from 'antd';
import { useTranslation } from 'react-i18next';

export interface IPagination {
  page: number; // Start from 1
  size: 25 | 50 | 100 | number;
  totalElements: number;
  onChange: PaginationProps['onChange'];
  isDisabled?: boolean;
}

const PaginationTable = ({
  page,
  size = 25,
  totalElements = 0,
  onChange,
  isDisabled,
}: IPagination): JSX.Element => {
  const { t } = useTranslation('Vindoc');

  return (
    <div className="pagination-table">
      <ConfigProvider
        theme={{
          token: {
            colorBgContainer: 'transparent',
          },
        }}
      >
        <Pagination
          className="text-black dark:text-white"
          size="small"
          current={page}
          pageSize={size}
          total={totalElements}
          showSizeChanger
          showQuickJumper
          showTotal={(total) => `${t('Total')} ${total} ${t('items')}`}
          onChange={onChange}
          disabled={isDisabled}
          pageSizeOptions={[25, 50, 100]}
        />
      </ConfigProvider>
    </div>
  );
};

export default PaginationTable;
